import Colorable from './Colorable';
export default Colorable;
